export default {
  apiKey: "AIzaSyAwrOYODzDPYhntXvKMEIioM4vXEQAr-Xw",
  authDomain: "mafiagame-b3de1.firebaseapp.com",
  databaseURL: "https://mafiagame-b3de1.firebaseio.com",
  projectId: "mafiagame-b3de1",
  storageBucket: "mafiagame-b3de1.appspot.com",
  messagingSenderId: "345002635849",
  appId: "1:345002635849:web:c59f66fec75bc6cf6f0598",
};
